/**
 * VehicleChargesTab - Sub-aba "Cobranças" da aba Financeiro do modal de veículo
 *
 * Espelha o comportamento de `CustomerChargesTab`, trocando o filtro de cliente
 * pelo filtro de veículo (`vehicle_id`) já suportado pela RPC
 * `get_cobrancas_paginated`. Exibe a coluna "Proprietário" para identificar
 * documentos emitidos por donos anteriores do veículo.
 *
 * @version 1.0.0
 * RELEASE: 2026-08-19 v1.0.0 - Criação (refatoração da aba Financeiro do veículo)
 */
import { useFinanceiroCobrancasPaginated } from '@/hooks/useFinanceiroCobrancasPaginated';
import { ChargesTableView } from '@/components/financial/ChargesTableView';

interface VehicleChargesTabProps {
  /** ID do veículo */
  vehicleId: string;
  /** Lazy loading: só busca quando a sub-aba estiver ativa */
  isActive?: boolean;
  /** Permissão para editar cobrança */
  canEdit?: boolean;
  /** Permissão para excluir/cancelar cobrança */
  canDelete?: boolean;
}

export function VehicleChargesTab({
  vehicleId,
  isActive = false,
  canEdit = true,
  canDelete = true,
}: VehicleChargesTabProps) {
  const { cobrancas, isLoading } = useFinanceiroCobrancasPaginated(
    isActive ? { vehicle_id: vehicleId } : undefined,
    { page: 1, pageSize: 200 },
  );

  return (
    <ChargesTableView
      charges={cobrancas}
      isLoading={isLoading}
      emptyMessage="Nenhuma cobrança encontrada para este veículo"
      canEdit={canEdit}
      canDelete={canDelete}
      showCustomer
      customerLabel="Proprietário"
    />
  );
}
